import { ONE_DAY_IN_MILLISECONDS } from 'src/constants/times.const';

export const twentyFourHoursAgo = (date: number): boolean => {
  return date > Date.now() - ONE_DAY_IN_MILLISECONDS;
};
